import React from 'react';
import './addcta.css'
import pic23 from '../../assets/pic23.png'

const AddCTA = (props) => {
    return ( 
        <button className='cta-event' type="button"           onClick={props.onClick}   >
                <img src={pic23} alt='add icon' className='iconnnn-addd-cta'></img>
                <h2 className='cta-event-text'>{props.title}</h2>
        </button>
     );
}
 
export default AddCTA;